import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../../common.css";
import "../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import SelectingWarrentImg from "../../../../../components/common/SelectingWarrentImg";



const ExerciseRatios = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const location = useLocation();
    const history = useHistory();
    const [openLive, setOpenLive] = useState(false);
    const [imageUrl, setImageUrl] = useState("");

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>

            <div id="main" className='Common_warrent share_capital'>
                <div id="maintable" style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                    <div style={{ display: 'table-row' }}>
                        <div id="leftbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }} />
                        <div id="maincontainer" style={{ display: 'table-cell', width: '100%' }}>
                            <div id="mainnav">
                                <table style={{ width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223' }}>
                                    <tbody><tr>
                                        <td width="20%" style={{ textAlign: 'left', visibility: 'hidden' }}>
                                            <table className="hasprev hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td width="33px"><div className="prev left" /></td>
                                                    <td>
                                                        <div className="prevlbl left">
                                                            <div className="prevtitle " style={{ textAlign: 'left' }} />
                                                            <div className="prevname " style={{ textAlign: 'left' }}>Delta</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                        <td width="60%" style={{ textAlign: 'center' }}>
                                            <div id="pagetitlediv" style={{ width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto' }}>
                                                <div id="ptitle" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px' }}>Useful Warrant terms</div>
                                                <div id="pname" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px' }}>Exercise Ratio</div>
                                            </div>
                                        </td>
                                        <td width="20%" style={{ textAlign: 'right', visibility: 'hidden' }}>
                                            <table className="hasnext  hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td>
                                                        <div className="nextlbl right">
                                                            <div className="nexttitle " style={{ textAlign: 'right' }} />
                                                            <div className="nextname " style={{ textAlign: 'right' }}>Warrant Sensitivity</div>
                                                        </div>
                                                    </td>
                                                    <td width="33px"><div className="next right" /></td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                            <div id="maincontent" style={{ marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px' }}>
                                <div id="mainscroll" style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px' }}>
                                    <div id="mainscrollcontent">
                                        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                                        {/*<link rel="stylesheet" href="css/common.css"/>*/}
                                        <title>Exercise Ratio</title>
                                        <style dangerouslySetInnerHTML={{ __html: "\n            .contentbox table{\n                margin: 0 auto;\n            }\n            .contentbox table thead th{\n                background-color: #FFD400;\n            }\n            .contentbox table tbody td,\n            .contentbox table thead th{\n/*                height:3em;*/\n                padding:0.5em 1em;\n                color:#000000;\n            }\n            .contentbox table tbody  tr:nth-child(even) td {background-color: #FFF4D2}\n            .contentbox table tbody  tr:nth-child(odd) td {background-color: #FFFF80}\n            .contentbox table thead th{\n                text-align:left;\n            }\n            .contentbox table tbody td.col1{\n                background-color: #FFF4D2;\n                text-align:left;\n                padding-left: 1em;\n            }\n            .contentbox table tbody td.col2{\n                background-color: #FFFF80;\n                text-align:center;\n            }\n            .contentbox table tbody td.col3{\n                background-color: #FFD400;\n                text-align:center;\n            }\n            .contentbox table tfoot td.disclaimer{\n                padding-top: 0.5em;\n                color: #FFFFFF;\n                font-size: 0.8em;\n            }\n            .nowrap{\n                white-space: nowrap;\n            }\n        " }} />
                                        <div className="contentbox">
                                            <p>
                                                Exercise Ratio (also known as warrants per share) shows the number of warrants needed to exchange for one underlying share/index futures at expiry. <br /><br />
                                                The purpose of exercise ratio is really just to break down the warrant into smaller parts, so that a warrant with a price of say MYR 1.00 can be broken down into smaller parts each worth MYR 0.20 by using an exercise ratio of 5.<br /><br />
                                                When calculating many indicators or ratios, such as delta, premium, etc you often need to take into account the exercise ratio. However, throughout this website, we have already done this for you and provided all the indicators you will need to make your decisions.
                                            </p>
                                            <div className="imgholder">
                                                <img style={{ maxWidth: '800px' }} src='/img/education/userful_wrnt_term_exercise_ratio.png' alt="image" />
                                                <div className="imgtxt">*Sensitivity change based on 10 ticks.</div>
                                                <div className="map_pop">
                                                    <div
                                                        className="how_put"
                                                        data-bs-toggle="collapse"
                                                        href="#popup-image"
                                                        role="text"
                                                        aria-expanded="false"
                                                        aria-controls="popup-image"
                                                        onClick={() =>{ return setOpenLive(true), setImageUrl("/img/education/userful_wrnt_term_exercise_ratioMob.png")}}
                                                    >View table
                                                    </div>
                                                </div>
                                            </div>
                                            <p>
                                                Let's take a look at an example to understand the effects of different exercise ratio. In the above table, all three warrants in the table above have the same exercise price, expiry date etc. with exercise ratio the only difference between them.<br /><br />
                                                Notice that Warrant-CA has an exercise ratio of 1 and therefore requires 1 warrant to exchange for one underlying share at expiry. It has a price of MYR 0.40.<br /><br />
                                                Warrant-CC on the other hand has an exercise ratio of 5 and requires 5 warrants to exercise at expiry, five times more than Warrant-CA. Therefore it costs exactly 5 times less at MYR 0.08.<br /><br />
                                                The delta per warrant for Warrant-CA, Warrant-CB and Warrant-CC will also be different as they have different exercise ratio figures. Remember that all three warrants are exactly the same, with the same exercise price and expiry. The delta for all three is therefore the same. However, the delta per warrant for Warrant-CA is higher as a result of being divided by a smaller exercise ratio of 1 compared to Warrant-CB for which the delta will be divided by 2. Warrant C will have the lowest delta per warrant of 10 per cent.<br /><br />
                                                The important point to understand is that while warrants with the lower exercise ratio will have a higher delta per warrant, they are also more expensive and therefore move the same in percentage terms. Meaning, if you purchased any of the above warrants, the return you will receive in percentage terms will be exactly the same. In this example, each of the warrants will move approximately 12.5% for a MYR 0.10 move in the underlying share.<br /><br />
                                                So while the exercise ratio is important for calculating ratios such as delta, sensitivity, breakeven price at expiry etc., it should not be a major factor in the decision making process for most warrant investors who are choosing a warrant.<br /><br />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                                </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
            >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                        display: "table",
                        width: "100%",
                        textAlign: "center",
                        color: "#8F8F8F",
                        fontSize: "11px",
                        lineHeight: "40px",
                    }}
                >
                    <div className='copyright_sec'>
                        Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                        reserved.
                    </div>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        right: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasnext"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="nextlbl right">
                                        <div
                                            className="nextname "
                                            style={{ textAlign: "right", fontSize: "15px" }}
                                        ><Link to="/edu/useful-warrant-terms/warrant-sensitivity">
                                                Warrant Sensitivity
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                                <td width="33px">
                                    <Link to="/edu/useful-warrant-terms/warrant-sensitivity">
                                        <div className="next right" />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        left: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasprev"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td width="33px">
                                    <Link to="/edu/useful-warrant-terms/delta">
                                        <div className="prev left" />
                                    </Link>
                                </td>
                                <td>
                                    <div className="prevlbl left">
                                        <div
                                            className="prevname "
                                            style={{ textAlign: "left", fontSize: "15px" }}
                                        ><Link to="/edu/useful-warrant-terms/delta">
                                                Delta
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <SelectingWarrentImg Open={openLive} OpenModel={() => setOpenLive(!true)} Data={imageUrl}/>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
                {/* <div className="dbtn dbtn-seminarbtn">
                    <Link
                        className="seminarbtn"
                        to="/education/seminar"
                    >
                        <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
    );
}
export default ExerciseRatios;